import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Drawer, Typography, Button, Divider } from '@mui/material';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// components
import { MHidden } from '../../components/@material-extend';
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { removeItemAction } from '../../redux/slices/dagpacket';
import { fCurrency } from '../../utils/formatNumber';
// import LanguagePopover from './LanguagePopover';
// import ContactsPopover from './ContactsPopover';
import NotificationsPopover from './NotificationsPopover';
import { analytics } from '../../contexts/FirebaseContext';
import { removeItemServRecAction } from '../../redux/slices/dagpacketServRec';
import { removeItemProducts } from '../../redux/slices/dagpacketProducts';
import { analyticsEvents } from '../../constants/analyticsEvents';
import useControlRoutes from '../../hooks/controlRoutes/useControlRoutes';
import useVersion from '../../hooks/useVersion';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const { isCollapse } = useCollapseDrawer();
  const { workMode } = useControlRoutes();
  const { versionApp } = useVersion();
  console.log(workMode);

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` }
        })
      }}
    >
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>
        {/* <Searchbar /> */}
        <Box>
          <Typography color="text.primary" textTransform="capitalize" variant="subtitle1">
            {workMode}
          </Typography>
          <Typography fontSize="12px" color="gray">
            V. {versionApp}
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Box>
          <CartButton />
        </Box>
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <NotificationsPopover />
          {/* <LanguagePopover />
          <ContactsPopover /> */}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}

const SpanContainer = styled('span')(() => ({
  position: 'absolute',
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  background: '#6f7378',
  top: '5px',
  right: '0px',
  color: '#fff',
  fontSize: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

function CartButton() {
  const [toggleCart, setToggleCart] = useState(false);
  // const navigate = useNavigate();
  const { checkout } = useSelector((state) => state.dagpacket);
  const { cartServRec } = useSelector((state) => state.dagpacketServRec);
  const { cartProducts } = useSelector((state) => state.dagpacketProducts);

  return (
    <>
      <IconButton
        size="large"
        sx={{ marginRight: '20px', position: 'relative' }}
        // onClick={() => navigate('/dashboard/cotizaciones/cart')}
        onClick={() => setToggleCart(true)}
      >
        <SpanContainer>{checkout.cart.length + cartServRec.length + cartProducts.length}</SpanContainer>
        <Icon icon="eva:shopping-cart-fill" />
      </IconButton>
      <CartProduct toggle={toggleCart} setToggle={setToggleCart} />
    </>
  );
}

const BoxSec = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '100px 1fr',
  textAlign: 'initial'
  // display: 'flex',
  // gap: '10px',
  // textAlign: 'initial'
}));

CartProduct.propTypes = {
  toggle: PropTypes.bool,
  setToggle: PropTypes.func
};

function CartProduct({ toggle, setToggle }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartServRec, totalServRec } = useSelector((state) => state.dagpacketServRec);
  const { cartProducts, totalProducts } = useSelector((state) => state.dagpacketProducts);
  const { checkout } = useSelector((state) => state.dagpacket);
  const { cart, total } = checkout;

  // console.log(cartServRec);

  const removeItem = (id) => {
    dispatch(removeItemAction(id));
  };

  const removeItemServRec = (id) => {
    dispatch(removeItemServRecAction(id));
  };

  const handleRemoveItemProducts = (id) => {
    dispatch(removeItemProducts(id));
  };

  return (
    <Drawer anchor="right" open={toggle} onClose={() => setToggle(false)}>
      <Box width="300px" padding={2}>
        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" component="h3" color="primary" sx={{ fontWeight: 600 }}>
              Cart
            </Typography>
            <IconButton color="error" size="large" onClick={() => setToggle(false)}>
              <Icon icon="eva:close-fill" />
            </IconButton>
          </Box>
          <Divider />
          {cart.length > 0 &&
            cart.map((item, i) => {
              const { object_id, city_from, city_to, shippingValue, name_from, name_to } = item;
              return (
                <Box key={i} marginTop={2}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                    <h6 style={{ fontSize: '16px' }}>
                      {city_from} a {city_to}
                    </h6>
                    <p style={{ fontSize: '15px' }}>{fCurrency(shippingValue)}</p>
                  </Box>
                  <Box>
                    <BoxSec>
                      <h5 style={{ fontSize: '14px' }}>Remitente:</h5>
                      <p style={{ fontSize: '14px' }}>{name_from}</p>
                    </BoxSec>
                    <BoxSec>
                      <h5 style={{ fontSize: '14px' }}>Destinatario:</h5>
                      <p style={{ fontSize: '14px' }}>{name_to}</p>
                    </BoxSec>
                  </Box>
                  <Box marginTop={2} textAlign="initial">
                    <IconButton color="error" onClick={() => removeItem(object_id)}>
                      <Icon icon="eva:trash-2-outline" />
                    </IconButton>
                  </Box>
                  <Divider />
                </Box>
              );
            })}

          {/* // servicios - recargas items */}

          {cartServRec.length > 0 &&
            cartServRec.map((item) => {
              const { name, enteredAmount, object_id } = item;

              return (
                <Box key={object_id} marginTop={2}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                    <h6 style={{ fontSize: '16px' }}>{name}</h6>
                    <p style={{ fontSize: '15px' }}>{fCurrency(enteredAmount)}</p>
                  </Box>

                  <Box marginTop={2} textAlign="initial">
                    <IconButton color="error" onClick={() => removeItemServRec(object_id)}>
                      <Icon icon="eva:trash-2-outline" />
                    </IconButton>
                  </Box>
                  <Divider />
                </Box>
              );
            })}
          {cartProducts.length > 0 &&
            cartProducts.map((item) => {
              const { name, price_complete, idProducto } = item;

              return (
                <Box key={idProducto} marginTop={2}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                    <h6 style={{ fontSize: '16px' }}>{name}</h6>
                    <p style={{ fontSize: '15px' }}>{fCurrency(price_complete)}</p>
                  </Box>

                  <Box marginTop={2} textAlign="initial">
                    <IconButton color="error" onClick={() => handleRemoveItemProducts(idProducto)}>
                      <Icon icon="eva:trash-2-outline" />
                    </IconButton>
                  </Box>
                  <Divider />
                </Box>
              );
            })}
        </Box>
        {(cart.length > 0 || cartServRec.length > 0 || cartProducts.length > 0) && (
          <>
            <Box marginTop={1} display="flex" justifyContent="space-between" alignItems="center">
              <Typography fontSize="25px" variant="subtitle1">
                Total:
              </Typography>
              <Typography fontSize="25px">{fCurrency(total + totalServRec + totalProducts)}</Typography>
            </Box>
            <Button
              fullWidth
              variant="contained"
              color="info"
              sx={{ marginTop: '15px' }}
              onClick={() => {
                navigate('/dashboard/cotizaciones/cart');
                setToggle(false);
                analytics.logEvent(analyticsEvents.purchase);
              }}
            >
              Pagar
            </Button>
          </>
        )}
        {cart.length === 0 && cartServRec.length === 0 && cartProducts.length === 0 && (
          <Box display="flex" flexDirection="column" gap="30px" alignItems="center" marginTop={4}>
            <img width="40%" src="/static/illustrations/empty_cart.svg" alt="cart" />
            <h6 style={{ fontSize: '15px', textAlign: 'center' }}>El carrito de compras está vacio.</h6>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}
